import { FC, useState, useCallback, useMemo } from 'react'
import cn from 'classnames'
import * as styles from 'components/features/pfm/Tooltip/TooltipIcon.css'
import Tooltip, { TooltipTheme } from 'components/features/pfm/Tooltip/Tooltip'
import Icon, { IconKind } from 'components/atoms/Icon'
import Touchable from 'components/utils/Touchable'
import { OuterEvent } from 'components/features/pfm/OuterEvent/OuterEvent'

export type TooltipIconShape = 'ellipsis' | 'question' | 'secure' | 'danger'

type TooltipIconProps = {
  theme?: TooltipTheme
  icon?: IconKind | TooltipIconShape
  wide?: boolean
  className?: string
  side?: 'bottom'
  onTooltipClick?: () => void
}
/**
 * @depracated - use features/TooltipIcon instead
 */
export const TooltipIcon: FC<TooltipIconProps> = (props) => {
  const {
    theme = 'info',
    icon,
    wide,
    className: outerClassName,
    side,
    onTooltipClick,
    children,
  } = props

  const [isPopupOpened, setPopupOpened] = useState(false)

  const className = cn(styles.tooltipIcon, {
    [styles.warning]: theme === 'warning',
    [styles.danger]: theme === 'danger',
    [styles.secure]: icon === 'secure',
    [styles.transparent]: icon === 'spinner-light',
    [styles.tooltipOpened]: isPopupOpened,
    [styles.wide]: wide,
  }, outerClassName)
  const containerClassName = cn(styles.tooltipContainer, {
    [styles.onBottom]: side === 'bottom',
  })

  const closePopup = useCallback(() => {
    setPopupOpened(false)
  }, [setPopupOpened])

  const openPopup = useCallback(() => {
    setPopupOpened(true)
  }, [setPopupOpened])

  const onTap = useCallback<HammerListener>(() => {
    if (!isPopupOpened) {
      openPopup()
    } else {
      if (onTooltipClick) {
        onTooltipClick()
      }
      closePopup()
    }
  }, [isPopupOpened, openPopup, closePopup, onTooltipClick])

  const cacheKey = useMemo(() => {
    return Math.random()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPopupOpened])

  return (
    <OuterEvent onOuterTap={ closePopup } className={ styles.outerWrapper }>
      <Touchable
        onTap={ onTap }
        onMouseEnter={ openPopup }
        onMouseLeave={ closePopup }
      >
        <div className={ className } data-icon={ icon }>
          <div className={ containerClassName }>
            <Tooltip
              key={ cacheKey }
              theme={ theme }
              light={ theme === 'danger' }
              wrap
              direction={ side === 'bottom' ? 'upLeft' : undefined }
              onClick={ onTooltipClick }
            >
              { children }
            </Tooltip>
          </div>
          { icon && <Icon kind={ icon } /> }
        </div>
      </Touchable>
    </OuterEvent>
  )
}

export default TooltipIcon
